import { z } from 'zod';
import { WSAutoApprovalStatus, WSEventType } from '~/enums';

export const wsAuthConfirmationSchema = z.object({
  action: z.literal('authorization'),
  responseCode: z.literal(200),
});

export const wsOfferMessageSchema = z.object({
  message: z.object({
    status: z.nativeEnum(WSAutoApprovalStatus).optional(),
    eventType: z.nativeEnum(WSEventType),
  }),
});
